import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';

const AffiliateBanner = () => {
  return (
    <div 
      className="affiliate-banner mb-8 flex items-start gap-3"
      data-testid="affiliate-banner"
    >
      <Info className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" />
      <p>
        <strong>Hinweis:</strong> Einige Links auf dieser Seite sind Affiliate-Links. 
        Wenn Sie über diese Links einen Dienst kaufen, erhalten wir möglicherweise eine 
        Provision — ohne Mehrkosten für Sie.{' '}
        <Link to="/affiliate-offenlegung" className="text-teal-600 hover:text-teal-700 underline underline-offset-2">
          Mehr erfahren
        </Link>
      </p>
    </div>
  );
};

export default AffiliateBanner;
